import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isPAYD: false,
    odometer_reading: 0,
};

export const isPAYDSlice = createSlice({
    name: "isPAYD",
    initialState,
    reducers: {
        setIsPAYD: (state, action) => {
            state.isPAYD = action.payload;
        },
        setOdometerReading: (state, action) => {
            state.odometer_reading = action.payload;
        },
    },
});

export const { setIsPAYD, setOdometerReading } = isPAYDSlice.actions;

export default isPAYDSlice.reducer;
